import { defineStore } from "pinia";
import { useWindowSize } from "@vueuse/core";
import { useRouter, useRoute } from "vue-router";
import { simpleCrypt, simpleDecrypt } from "@/assets/js/helpers";
import api from "@/api";
import { useToastStore } from "./toast";

export const useDefaultStore = defineStore("main", () => {
	const { width } = useWindowSize();
	const isMobileToggled = ref(false);
	const router = useRouter();
	const route = useRoute();

	const intervalId = ref<ReturnType<typeof setInterval>>();

	const driverReportCount = ref(0);
	const unseenReportCount = ref(0);

	const getDriverReportCount = computed(() => driverReportCount.value);
	const getUnseenReportCount = computed(() => unseenReportCount.value);

	const isMobileSize = computed(() => width.value < 768);
	const isMobileView = computed(
		() => isMobileSize.value && isMobileToggled.value,
	);

	async function fetchTodayReports() {
		try {
			const res = await api.getTodaysReports();
			const responseData = res.data.data;

			const oldValue = unseenReportCount.value;

			driverReportCount.value = Number(responseData.count || 0);
			unseenReportCount.value = Number(responseData.count_unseen || 0);
			if (oldValue < unseenReportCount.value) {
				const ts = useToastStore();
				ts.openToastInfo("Nova loše ocenjena vožnja");
			}
		} catch {
			driverReportCount.value = 0;
			unseenReportCount.value = 0;
		}
	}

	function setUpReportInterval() {
		if (intervalId.value) {
			console.warn(
				"Recalling setup interval - please only call `setUpReportInterval` once. Old interval cleared",
			);
			clearInterval(intervalId.value);
		}
		fetchTodayReports();
		intervalId.value = setInterval(fetchTodayReports, 15_000);
	}

	function clearReportInterval() {
		if (intervalId.value) {
			clearInterval(intervalId.value);
			intervalId.value = undefined;
		}
	}

	onScopeDispose(() => {
		clearReportInterval();
	});

	watch(isMobileSize, (val) => {
		if (!val) {
			isMobileToggled.value = false;
		}
	});

	function decodePath(name: string) {
		return simpleDecrypt("abc", name);
	}
	function encodePath(name: string) {
		return simpleCrypt("abc", name);
	}
	async function onClickLoginPage() {
		// Used to return user to the previous page
		const currentPageName = String(route.name);

		// Exceptions - Auth pages
		let ppn: string | undefined = encodePath(currentPageName);
		if (route.matched.some((rt) => rt.name === "AuthPage")) {
			ppn = undefined;
		}

		await router.push({
			name: "LoginPage",
			query: {
				ppn,
			},
		});
	}

	async function goToProfilePage() {
		await router.push({
			// name: "SettingsPage",
			// name: "ProfilePage",
			name: "LoginPage",
		});
	}

	return {
		isMobileToggled,
		isMobileView,
		decodePath,
		encodePath,
		onClickLoginPage,
		setUpReportInterval,
		goToProfilePage,
		clearReportInterval,
		getDriverReportCount,
		getUnseenReportCount,
	};
});
